/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const goodLuckCoreDTOsReplayGameScoreDtoSchema = z.object({
  userId: z.string().nullish(),
  gameId: z.int().nullish(),
  glScore: z.number().nullish(),
  champion: z.string().nullish(),
  win: z.boolean().nullish(),
  integrityFlags: z.array(z.string()).nullish(),
});
